export default {"src":"https://images-cdn-staging.curipod.com/d-49646873/_next/static/media/gwinnett_county.1b5c2fe8.svg","height":86,"width":267};